import React from 'react';
import PropTypes from 'prop-types';

import ShareDialog from "Components/ShareDialog";
import PublishStoryModal from "Components/PublishStoryModal";

import { DotsVerticalIcon } from "@heroicons/react/solid";
import { ExternalLinkIcon, PlayIcon, EyeIcon } from "@heroicons/react/outline";
import Dropdown from "../../ui/Dropdown";

export default class StorySettingsMenu extends React.Component
{
    state = {
        showShareModal: false,
        showPublishModal: false,
    };

    static propTypes = {
        story: PropTypes.object.isRequired
    };

    render()
    {
        const { story } = this.props;

        return <>
            <Dropdown button={Dropdown.VerticalDotsButton} origin='tr'>
                <Dropdown.LinkItem to={`/stories/${story.id}`}>
                    <PlayIcon className='h-4 w-auto' aria-hidden="true" />
                    <span>Preview</span>
                </Dropdown.LinkItem>

                <Dropdown.Item onClick={() => {this.setState({showShareModal: true})}}>
                    <ExternalLinkIcon className='h-4 w-auto' aria-hidden="true" />
                    <span>Share</span>
                </Dropdown.Item>

                <Dropdown.Item onClick={() => {this.setState({showPublishModal: true})}}>
                    <EyeIcon className='h-4 w-auto' />
                    <span>Publish</span>
                </Dropdown.Item>
            </Dropdown>

            <ShareDialog
                open={this.state.showShareModal}
                onClose={() => this.setState({showShareModal: false})}
                story={story}
            />

             <PublishStoryModal
                 story={story}
                 open={this.state.showPublishModal}
                 onClose={() => this.setState({showPublishModal: false})}
             />
        </>
    }
}
